<script>
  import navigation from "../../constants/navigation";
  import { scrollto } from "svelte-scrollto";
</script>

<style>
  nav {
    padding: 1rem;
  }
  .nav a {
    color: var(--color-theme-4);
    text-transform: uppercase;
  }
  .nav a:hover {
    text-decoration: underline;
  }
</style>

<nav class="nav">
  <div class="nav-center">
    {#each navigation as item}
      <a href={item.url} use:scrollto={item.url}>{item.text}</a>
    {/each}
    <a href="./resume/guybriggs.pdf" target="_blank">Resume</a>
  </div>
</nav>
